import BoxContainer from "@standard/components/BoxContainer/BoxContainer";
import { useParams } from "react-router-dom";
import { useState, memo } from "react";
import DataForm from "@standard/components/DataForm/DataForm";
import { DatasourceAPI, UserAPI } from "api";
import { AlertService, ErrorService, FormService } from "@standard/services";
import { useEffect } from "react";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { USER_ROLE, USER_STATUS } from "data/constants";
import { Controller, useForm } from "react-hook-form";
import { UserRoleData } from "data";
import { FILE_INPUT_EXTENSION } from "@standard/components/FileInput";

export default function UserForm({ history, url }) {
  const { id, action } = useParams();
  const [buttons, setButtons] = useState([]);
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [disabled, setDisabled] = useState(action === "view");

  const [datasource, setDatasource] = useState({
    userRole: UserRoleData,
  });

  const defaultValues = {
    id: id,
    username: "",
    name: "",
    email: "",
    roles: [],
    active: true,
    status: USER_STATUS.ACTIVE,
  };

  const reactHookForm = useForm({ defaultValues });

  useEffect(() => {
    if (id !== undefined) {
      retrieveData(id);
    } else {
      // const tables = ["menuprofile"];
      // DatasourceAPI.getActiveDatasource(tables).then((datasourceResult) => {
      //   setDatasource((prev) => {
      //     return { ...prev, ...datasourceResult };
      //   });

      setIsLoading(false);
      // });
    }
  }, []);

  const retrieveData = (id) => {
    FormService.getRequest(url, id).then((result) => {
      reactHookForm.reset(result);
      setIsLoading(false);
    });
  };

  const saveData = (newData) => {
    setIsLoading(true);

    const params = { ...newData, id: id };

    FormService.submitRequestWithFile(url, params)
      .then(() => {
        setIsLoading(false);
        setErrors([]);
        history.push(`/${url}`);
      })
      .catch((err) => {
        console.log("Catch error", err);
        setIsLoading(false);
        setErrors(err);
      });
  };

  const onSubmit = (newData) => {
    AlertService.confirm("Do you want to save data").then((res) => {
      if (res === true) saveData(newData);
    });
  };

  const fields = [
    {
      label: "Name",
      name: "name",
      type: "label",
      col: 6,
    },
    {
      label: "Email",
      name: "email",
      type: "label",
      col: 6,
    },
    {
      label: "Roles",
      name: "roles",
      type: "ddl",
      datasource: datasource.userRole,
      multiple: true,
      disabled: disabled,
      col: 12,
    },
    {
      label: "Avatar",
      name: "avatarAssetId",
      type: "file",
      multiple: false,
      disabled: disabled,
      extension: FILE_INPUT_EXTENSION.IMAGE,
      col: 12,
    },
    {
      type: "custom",
      control: reactHookForm.getValues("avatarAssetPreview") && (
        <div className="col-12">
          <img
            alt="avartar"
            style={{ width: "150px", height: "150px" }}
            className="rounded rounded-circle"
            src={reactHookForm.getValues("avatarAssetPreview").url}
          />
        </div>
      ),
    },
  ];

  const fieldErrors = ErrorService.convertToArray(
    reactHookForm.formState.errors
  );

  return (
    <BoxContainer loading={isLoading} errors={errors.concat(fieldErrors)}>
      <DataForm
        refForm={reactHookForm}
        onSubmit={onSubmit}
        fields={fields}
        url={url}
        buttons={buttons}
        enableSave={!disabled}
      ></DataForm>
    </BoxContainer>
  );
}
